/**
 * Default duration for general toast presentation
 */
export const DEFAULT_DURATION = 5000;
